// extracted by mini-css-extract-plugin
export default {"emulated-flex-gap":"NJCgm","card":"JMDWf"};